import React from 'react';
import { useTranslation } from 'react-i18next';

import Modal from '@common/modal/modal';

import BoonButterflyIcon from '@assets/svg/boon-butterfly.svg';
import styles from './modal.styles';
import Markup from '../../markup/markup';

const SignupSuccessModal: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Modal
            id="signup-success"
            width="w-11/12 max-w-sm"
            contentWrapperClass="relative font-gr-book text-center text-black"
            titleBarClass="mt-4 mr-4"
        >
            <style jsx>{styles}</style>

            <div className="signup-success-container -mt-4">
                <img width="35" className="mr-auto ml-auto" src={BoonButterflyIcon} />
                <Markup className="text-lg py-2" content={t('base:signup-success-header')} />
                <Markup className="text-xs pb-6" content={t('base:signup-success-content')} />
            </div>

            <div className="bg-super-boon px-4 py-4">
                <Markup
                    className="text-center font-hairline sm:tracking-wider text-white text-xs"
                    content={t('base:signup-success-footer')}
                />
            </div>
        </Modal>
    );
};

export default SignupSuccessModal;
